// src/lib/pto/constants.ts
/** PTO request limits (spec R3, R4; DECISIONS 2026-10-15). */
export const PTO_FULL_DAY_HOURS = 8;
export const PTO_HALF_DAY_HOURS = 4;
export const PTO_MAX_SPAN_DAYS = 120;
export const PTO_NOTE_MAX = 500;

/** 0.25, 0.5, ... 8 (Vinyl's TimeEntryTimeValue list, capped at a full day). */
export const PTO_HOUR_OPTIONS: readonly number[] = Array.from(
  { length: 32 },
  (_, i) => (i + 1) / 4,
);

export function isQuarterStep(n: number): boolean {
  return Number.isFinite(n) && Math.abs(n * 4 - Math.round(n * 4)) < 1e-9;
}
